export default users => {
    let res = [];

    const map = new Map();
    for (const user of users) {
        if (!map.has(user.id)) {
            map.set(user.id, true); // set any value to Map
            res.push({
                id: user.id,
                name: user.name,
            });
        }
    }
    return res;
};
